// extracted by mini-css-extract-plugin
module.exports = {"spinner":"LightSpinner_spinner__FYNvg","spin":"LightSpinner_spin__1hp1o"};